import { axiosInstance } from '@/lib/axios';
import type { CanaryMe } from './types';

export const getMe = async (): Promise<CanaryMe> => {
  const { data } = await axiosInstance.get<CanaryMe>('/api/canary/me');
  return data;
};
